import { render, staticRenderFns } from "./RemoveAgentDialog.vue?vue&type=template&id=5365c5ce&"
import script from "./RemoveAgentDialog.vue?vue&type=script&lang=ts&"
export * from "./RemoveAgentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports